import layoutEngine from '../libraries/layoutEngine';
import ProjectManager from '../canvas/ProjectManager';

export default class InstancePlacementHandler {
  constructor(canvasEngine) {
    this.engine = canvasEngine;
  }

  // updatePreview(e) {
  //   const ref = ProjectManager.getSelectedInstanceCell();
  //   if (!ref) return;
  
  //   const cell = layoutEngine.getCellByName(ref);
  //   if (!cell) {
  //     console.warn("❌ Cannot find cell for ref:", ref);
  //     return; // 🔥 Avoid crash
  //   }
  
  //   const { offsetX, offsetY, scale } = this.engine;
  //   const snappedX = this.engine.snapToGrid((e.offsetX - offsetX) / scale);
  //   const snappedY = this.engine.snapToGrid((e.offsetY - offsetY) / scale);
  
  //   this.engine.previewInstance = { ref, x: snappedX, y: snappedY };
  //   this.engine.draw();
  // }
  updatePreview(e) {
  const ref = ProjectManager.getSelectedInstanceCell();
  if (!ref) return;

  const cell = layoutEngine.getCellByName(ref);
  // const cell = layoutEngine.getCell(ref);
  if (!cell) return;

  const { offsetX, offsetY, scale } = this.engine;
  const canvasX = (e.offsetX - offsetX) / scale;
  const canvasY = (e.offsetY - offsetY) / scale;

  const snappedX = this.engine.snapToGrid(canvasX);
  const snappedY = this.engine.snapToGrid(canvasY);

  // ⬇️ Get bounding box of the instance
  const bounds = this.engine.getChildBoundingBox(cell);

  // ⬅️ Adjust preview so that (0,0) of instance lands at mouse
  const adjustedX = snappedX - bounds.x;
  const adjustedY = snappedY - bounds.y;
  // const adjustedX = snappedX - bounds.x;
// const adjustedY = snappedY - bounds.maxY;

  this.engine.previewInstance = { ref, x: adjustedX, y: adjustedY };
  this.engine.draw();
}

  
//   finalizePlacement() {
//   if (!this.engine.previewInstance) return;

//   const { ref, x, y } = this.engine.previewInstance;
//   const cellName = ProjectManager.getSelectedCell();
//   const currentCell = layoutEngine.getCellByName(cellName);

//   const cell = layoutEngine.getCellByName(ref);
//   const { offsetX, offsetY } = this.engine.getChildBoundingBoxCenterOffset(cell);

//   // 🔄 Recalculate and snap again (to be 100% sure it's aligned)
//   const snappedCanvasX = this.engine.snapToGrid(x + offsetX);
//   const snappedCanvasY = this.engine.snapToGrid(y + offsetY);
//   const finalX = snappedCanvasX - offsetX;
//   const finalY = snappedCanvasY - offsetY;

//   // ✅ Updated duplicate check based on snapped position
//   if (currentCell?.instances?.some(inst => inst.ref === ref && inst.x === finalX && inst.y === finalY)) {
//     console.warn("🛑 Skipping duplicate instance placement");
//     this.engine.previewInstance = null;
//     this.engine.draw();
//     return;
//   }

//   // Add the instance to the current cell with the adjusted final positions
//   layoutEngine.addInstance(cellName, ref, finalX, finalY);

//   this.engine.previewInstance = null;
//   this.engine.draw();
// }
finalizePlacement() {
  if (!this.engine.previewInstance) return;

  const { ref, x, y } = this.engine.previewInstance;

  const parentCellName = ProjectManager.getSelectedCell();
  const mergedRefCell = layoutEngine.getCellByName(ref);
  if (!mergedRefCell) return;

  // 🔑 SAME bbox logic as preview
  const bounds = this.engine.getChildBoundingBox(mergedRefCell);

  const snappedX = this.engine.snapToGrid(x + bounds.x);
  const snappedY = this.engine.snapToGrid(y + bounds.y);
//   const snappedX = this.engine.snapToGrid(x + bounds.x);
// const snappedY = this.engine.snapToGrid(y + bounds.maxY);

// const finalX = snappedX - bounds.x;
// const finalY = snappedY - bounds.maxY;

  // 🔑 Store canonical placement (relative to cell origin)
  const finalX = snappedX - bounds.x;
  const finalY = snappedY - bounds.y;

  layoutEngine.addInstance(parentCellName, ref, finalX, finalY);
  window.dispatchEvent(
  new CustomEvent("instance-placed", {
    detail: { ref, parentCellName, x: finalX, y: finalY },
  })
);

  this.engine.previewInstance = null;
  this.engine.draw();
}

// finalizePlacement() {
//   if (!this.engine.previewInstance) return;

//   const { ref, x, y } = this.engine.previewInstance;
//   // const cell = layoutEngine.getCellByName(ref);
//   const cell = layoutEngine.getMergedCell(ref);
//   const cellName = ProjectManager.getSelectedCell();
//   // const currentCell = layoutEngine.getCellByName(cellName);
//   const currentCell = layoutEngine.getMergedCell(cellName);
//   if (!cell) return;

//   const snappedX = this.engine.snapToGrid(x);
//   const snappedY = this.engine.snapToGrid(y);
//   const finalX = snappedX;
//   const finalY = snappedY;

//   // ✅ Updated duplicate check based on snapped position
//   if (currentCell?.instances?.some(inst => inst.ref === ref && inst.x === finalX && inst.y === finalY)) {
//     console.warn("🛑 Skipping duplicate instance placement");
//     this.engine.previewInstance = null;
//     this.engine.draw();
//     return;
//   }

//   layoutEngine.addInstance(cellName, ref, snappedX, snappedY);
//   this.engine.previewInstance = null;
//   this.engine.draw();
// }


  
  
  
}
